import React from 'react';
import { useI18n } from '@oneaudi/i18n-context';
import { messages } from '../../../i18n/messages';
import { useIsMobileScreen } from '../../../hooks/useWindowSize';
import {
  MobileSearchInThisAreaButtonContainer,
  SearchInThisAreaButtonContainer,
} from '../Map/Map.styled';
import mapContext from '../../../contexts/map-context';
import { handleSearchThisArea } from './SearchThisAreaButton.handlers';
import trackingContext from '../../../contexts/tracking-context';
import { trackSearchThisAreaButtonAction } from '../../../utils/trackingUtils';
import { useURLService } from '../../../hooks/useURLService';

const MAX_ZOOM_LEVEL_FOR_SEARCH_AREA = 9;
const isLegacy = process.env.IS_LEGACY;

const shouldShowButton = (
  searchInThisAreaVisible: boolean,
  zoom: number,
  selectedDealerId: string | null,
) => {
  if (searchInThisAreaVisible && zoom > MAX_ZOOM_LEVEL_FOR_SEARCH_AREA && !selectedDealerId)
    return true;

  return false;
};

export default function SearchInThisAreaButton() {
  const isMobileScreen = useIsMobileScreen();
  const { selectedDealerId, mapZoom, searchInThisAreaVisible, searchText, userSelectedFilters } =
    mapContext.useMapState();
  const onSearchThisArea = handleSearchThisArea();
  const text = useI18n(messages.search_in_this_area);
  const { trackingService: tService } = trackingContext.useTrackingState();
  const generateURL = useURLService();

  const Container = isMobileScreen ? MobileSearchInThisAreaButtonContainer : React.Fragment;
  const dataTestId = isMobileScreen
    ? 'search-in-this-area-button-mobile-container'
    : 'search-in-this-area-button-container';

  function SearchThisArea() {
    const currentUrl = window.location.href;
    const payload = {
      query: searchText,
      filters: userSelectedFilters,
    };
    const url = generateURL(currentUrl, payload);
    onSearchThisArea();
    trackSearchThisAreaButtonAction(tService, text, 'SearchThisAreaButton', url.href);
  }

  return shouldShowButton(searchInThisAreaVisible, mapZoom, selectedDealerId) ? (
    <Container>
      <SearchInThisAreaButtonContainer
        variant={isLegacy ? 'primary' : 'secondary'}
        size={isMobileScreen ? 'sm' : 'md'}
        // eslint-disable-next-line react/jsx-no-bind
        onClick={SearchThisArea}
        data-test-id={dataTestId}
        isMobile={isMobileScreen}
      >
        {text}
      </SearchInThisAreaButtonContainer>
    </Container>
  ) : null;
}
